import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Container } from '@material-ui/core';
import { useStyles } from './styles';
import { DepartmentUserTable } from 'components/Tables/DepartmentUserTable/departmentUser';
const DepartmentUsers: FC = observer(() => {
  const classes = useStyles();
  return (
    <Container maxWidth='xl' className={classes.container}>
      <DepartmentUserTable />
    </Container>
  );
});

export default DepartmentUsers;
